import React from 'react';
import PropTypes from 'prop-types';
import TranslationProvider from '../../providers/TranslationProvider';
import Input from './Input';

import {
  length,
  letter,
  number,
  specialChar,
} from './PasswordCriteria';

const ariaLabelRequirements = [
  length,
  letter,
  number,
  specialChar,
].reduce(
  // eslint-disable-next-line no-return-assign
  (iter, val) => iter += ` ${val.translationText}`,
  'Password: '
);

const PasswordInput = ({
  ariaLabel,
  errors,
  name,
  placeholder,
  type,
  ariaRequired,
  ...props
}) => {
  const autocomplete = type === 'new'
    ? 'new-password'
    : 'current-password';

  return (
    <>
      <TranslationProvider
        translationKey="password"
      >
        <Input
          {...props}
          ariaLabel={ariaLabel || ariaLabelRequirements}
          ariaRequired={ariaRequired}
          name={name || 'password'}
          type="password"
          autocomplete={autocomplete}
          placeholder={placeholder || 'Password'}
          errors={errors}
          maxlength="25"
        />
      </TranslationProvider>
    </>
  );
};

PasswordInput.propTypes = {
  ariaLabel: PropTypes.string,
  ariaRequired: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(['new', 'current']),
};

PasswordInput.defaultProps = {
  ariaLabel: undefined,
  ariaRequired: false,
  errors: [],
  name: undefined,
  placeholder: undefined,
  type: 'new',
};

export default PasswordInput;
